import { TranslationClient, Group } from '@/api';

const client = new TranslationClient();

export async function getGroupsWithTranslations(groups: (Group & { text?: string; })[], localLang) {
  const allTranslations = await client.getAllTranslationsMap();
  let groupsTranslations = [];

  // if no translations or groups just the groups.
  if (!allTranslations.length || !groups.length) {
    return groups;
  }

  // find the group name translation and set the group name.
  groupsTranslations = groups.map((item) => {
    const newItem = { ...item };
    const translationItem = allTranslations.find((transItem) => transItem.phrase === item.id);

    if (translationItem) {
      newItem.name = translationItem[localLang] || '';
      newItem.text = translationItem[localLang] || '';
    } else {
      newItem.name = '';
      newItem.text = '';
    }
    return newItem;
  });

  return groupsTranslations;
}

export default getGroupsWithTranslations;
